// extracted by mini-css-extract-plugin
export default {"paymentsContainer":"Payments_paymentsContainer__kOlsw","paymentsRow":"Payments_paymentsRow__UhsVo","singlePayment":"Payments_singlePayment__yrBRv"};